import ConditionalEnd from "../../components/ActivedElements/ConditionalEnd";
import ConditionalStart from "../../components/ActivedElements/ConditionalStart";
import EventEnd from "../../components/ActivedElements/EventEnd";
import EventStart from "../../components/ActivedElements/EventStart";
import ActiveTaskNode from "../../components/ActivedElements/ActiveTaskNode";
import CustomEdge from "../../components/ActivedElements/CustomEdge";
import CustomEdgeWithoutLabel from "../../components/ModelElements/CustomEdgeWithoutLabel";
import Task from "../../components/ModelElements/Task";
import ParallelStart from "../../components/ActivedElements/ParallelStart";
import ParallelEnd from "../../components/ActivedElements/ParallelEnd";
import TimerEvent from "../../components/ActivedElements/TimerEvent";
import CustomMark from "../../components/ActivedElements/CustomMark";
import CustomTextForView from "../../components/ActivedElements/CustomTextForView";
import CustomNote from "../../components/ActivedElements/Note";

export const nodeTypes = {
  task: ActiveTaskNode,
  modelTask: Task,
  eventStart: EventStart,
  eventEnd: EventEnd,
  conditional: ConditionalStart,
  conditionalEnd: ConditionalEnd,
  parallel: ParallelStart,
  parallelEnd: ParallelEnd,
  timerEvent: TimerEvent,
  customMark: CustomMark,
  customText: CustomTextForView,
  CustomNote: CustomNote,
};

export const edgeTypes = {
  customEdge: CustomEdge,
  customEdgeWithoutLabel: CustomEdgeWithoutLabel,
};

export const ganttData = {
  jobs: [
    {
      id: "j1",
      start: new Date("2022-06-01T13:51:50"),
      end: new Date("2022/6/4"),
      label: "Tarefa 1",
      type: "task",
      status: "done",
      connections: ["p1"],
    },
    {
      id: "p1",
      start: new Date("2022-06-04T13:51:50"),
      end: new Date("2022/6/5"), //irrelevante
      type: "parallel",
      status: "doing",
      connections: ["j2", "j5", "j6"],
    },
    {
      id: "j2",
      start: new Date("2022-06-04T13:51:50"),
      end: new Date("2022/6/13"),
      label: "Tarefa 2",
      type: "task",
      status: "doing",
      connections: ["c1"],
    },
    {
      id: "c1",
      start: new Date("2022-06-13T13:51:50"),
      end: new Date("2022/6/14"), //irrelevante
      type: "conditional",
      status: "pending",
      connections: ["t3", "j4"],
    },
    {
      id: "t3",
      start: new Date("2022-06-13T13:51:50"),
      end: new Date("2022-06-21T13:51:50"),
      type: "timer",
      status: "pending",
      connections: ["j5"],
    },
    {
      id: "j4",
      start: new Date("2022-06-13T13:51:50"),
      end: new Date("2022/6/21"),
      label: "Tarefa 4",
      type: "task",
      status: "doneLate",
      connections: ["j5"],
    },
    {
      id: "j5",
      start: new Date("2022-06-21T13:51:50"),
      end: new Date("2022/6/26"),
      label: "Tarefa 5",
      type: "task",
      status: "late",
      connections: [],
    },
    {
      id: "j6",
      start: new Date("2022-07-06T13:51:50"),
      end: new Date("2022/7/12"),
      label: "Tarefa 6",
      type: "task",
      status: "pending",
      connections: [],
    },
  ],
};

export const initialFlow = [
  {
    id: "50558059-8d5e-483d-b8a1-2bd744ad5a39",
    type: "eventStart",
    position: {
      x: 619.4962263146149,
      y: 365.45024229423643,
    },
    data: {
      label: "Evento de início",
      status: "done",
      startedAt: "2022-07-10T13:51:50",
      finishedAt: "2022-07-10T13:51:50",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "02d5e0d2-e546-45af-991a-9647332dfa1c",
    type: "task",
    position: {
      x: 780.4962263146149,
      y: 546.4502422942364,
    },
    data: {
      label: "Tarefa1",
      status: "done",
      startedAt: "2022-07-10T13:51:50",
      finishedAt: "2022-07-14T13:51:50",
      expiration: {
        number: 120,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "289040f7-4336-43fa-90ad-63c8109719bc",
    type: "parallel",
    position: {
      x: 1129.3096675581844,
      y: 490.5960153819681,
    },
    data: {
      label: "Paralelo",
      status: "done",
      startedAt: "2022-07-14T13:51:50",
      finishedAt: "2022-07-14T13:52:50",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "a830c005-4c23-47fa-a6df-3fa1701cfc78",
    type: "task",
    position: {
      x: 1357.1212216196718,
      y: 331.1435986621167,
    },
    data: {
      label: "Tarefa2",
      status: "doing",
      startedAt: "2022-07-14T13:52:50",
      expiration: {
        number: 720,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "04235622-a676-4e15-b77d-ef4c46b16696",
    type: "task",
    position: {
      x: 1122.41238284681,
      y: 685.5744864824151,
    },
    data: {
      label: "Tarefa3",
      status: "doing",
      startedAt: "2022-07-14T13:52:50",
      expiration: {
        number: 360,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },

  {
    id: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    type: "conditional",
    position: {
      x: 1480.359959666273,
      y: 652.6076567020166,
    },
    data: {
      label: "Início da condicional",
      status: "pending",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "d5165962-aa85-4e34-b93c-9de8dcb86d6f",
    type: "timerEvent",
    position: {
      x: 1855.2976294267874,
      y: 533.6649072876598,
    },
    data: {
      status: "pending",
      expiration: {
        number: 240,
        time: "days",
      },
    },
  },
  {
    id: "4b56d881-879f-4884-9dab-cb2136a644ae",
    type: "task",
    position: {
      x: 1878.052113691489,
      y: 754.6188162804491,
    },
    data: {
      label: "Tarefa4",
      status: "pending",
      expiration: {
        number: 120,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    type: "conditionalEnd",
    position: {
      x: 2190.8663114828646,
      y: 634.7109982948706,
    },
    data: {
      label: "Fim da condicional",
      status: "pending",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    type: "parallelEnd",
    position: {
      x: 2350.8867094521047,
      y: 475.25350632229777,
    },
    data: {
      label: "Fim do paralelo",
      status: "pending",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "000000-a676-4e15-b77d-ef4c46b16696",
    type: "task",
    position: {
      x: 2600.41238284681,
      y: 500.5744864824151,
    },
    data: {
      label: "Tarefa5",
      status: "pending",
      expiration: {
        number: 120,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "2c18d65f-c9c1-497b-9ac1-d35893ae2820",
    type: "eventEnd",
    position: {
      x: 2950.4975834251786,
      y: 511.1326286194993,
    },
    data: {
      label: "Evento de fim",
      status: "pending",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    source: "50558059-8d5e-483d-b8a1-2bd744ad5a39",
    sourceHandle: "a",
    target: "02d5e0d2-e546-45af-991a-9647332dfa1c",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-50558059-8d5e-483d-b8a1-2bd744ad5a39a-02d5e0d2-e546-45af-991a-9647332dfa1cc",
  },
  {
    source: "02d5e0d2-e546-45af-991a-9647332dfa1c",
    sourceHandle: "a",
    target: "289040f7-4336-43fa-90ad-63c8109719bc",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-02d5e0d2-e546-45af-991a-9647332dfa1ca-289040f7-4336-43fa-90ad-63c8109719bcc",
  },
  {
    source: "289040f7-4336-43fa-90ad-63c8109719bc",
    sourceHandle: "a",
    target: "a830c005-4c23-47fa-a6df-3fa1701cfc78",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-289040f7-4336-43fa-90ad-63c8109719bca-a830c005-4c23-47fa-a6df-3fa1701cfc78c",
  },
  {
    source: "289040f7-4336-43fa-90ad-63c8109719bc",
    sourceHandle: "a",
    target: "04235622-a676-4e15-b77d-ef4c46b16696",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-289040f7-4336-43fa-90ad-63c8109719bca-04235622-a676-4e15-b77d-ef4c46b16696c",
  },
  {
    source: "a830c005-4c23-47fa-a6df-3fa1701cfc78",
    sourceHandle: "a",
    target: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    targetHandle: "b",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-a830c005-4c23-47fa-a6df-3fa1701cfc78a-4ef395e4-3648-477e-a249-2fb1fdd18c81b",
  },
  {
    source: "04235622-a676-4e15-b77d-ef4c46b16696",
    sourceHandle: "a",
    target: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-04235622-a676-4e15-b77d-ef4c46b16696a-b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0c",
  },
  {
    source: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    sourceHandle: "a",
    target: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    targetHandle: "b",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-ba2536cd-e735-4706-b14f-79962afdb9b8a-4ef395e4-3648-477e-a249-2fb1fdd18c81b",
  },
  //AQui

  {
    source: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    sourceHandle: "a",
    target: "000000-a676-4e15-b77d-ef4c46b16696",
    targetHandle: "a",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-4ef395e4-3648-477e-a249-2fb1fdd18c81a-000000-a676-4e15-b77d-ef4c46b16696",
  },
  {
    source: "000000-a676-4e15-b77d-ef4c46b16696",
    sourceHandle: "a",
    target: "2c18d65f-c9c1-497b-9ac1-d35893ae2820",
    targetHandle: "a",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-4000000-a676-4e15-b77d-ef4c46b16696a-2c18d65f-c9c1-497b-9ac1-d35893ae2820a",
  },
  {
    source: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    sourceHandle: "a",
    target: "d5165962-aa85-4e34-b93c-9de8dcb86d6f",
    targetHandle: "a",
    type: "customEdge",
    data: {
      text: "Etiqueta 1",
      status: "pending",
    },
    id: "reactflow__edge-b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0a-d5165962-aa85-4e34-b93c-9de8dcb86d6fa",
  },
  {
    source: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    sourceHandle: "a",
    target: "4b56d881-879f-4884-9dab-cb2136a644ae",
    targetHandle: "c",
    type: "customEdge",
    data: {
      text: "Etiqueta 2",
      status: "pending",
    },
    id: "reactflow__edge-b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0a-4b56d881-879f-4884-9dab-cb2136a644aec",
  },
  {
    source: "d5165962-aa85-4e34-b93c-9de8dcb86d6f",
    sourceHandle: "a",
    target: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-d5165962-aa85-4e34-b93c-9de8dcb86d6fa-ba2536cd-e735-4706-b14f-79962afdb9b8c",
  },
  {
    source: "4b56d881-879f-4884-9dab-cb2136a644ae",
    sourceHandle: "a",
    target: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-4b56d881-879f-4884-9dab-cb2136a644aea-ba2536cd-e735-4706-b14f-79962afdb9b8c",
  },
];

export const initialFlowCond = [
  {
    id: "50558059-8d5e-483d-b8a1-2bd744ad5a39",
    type: "eventStart",
    position: {
      x: 619.4962263146149,
      y: 365.45024229423643,
    },
    data: {
      label: "Evento de início",
      status: "done",
      startedAt: "2022-07-10T13:51:50",
      finishedAt: "2022-07-10T13:51:50",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "02d5e0d2-e546-45af-991a-9647332dfa1c",
    type: "task",
    position: {
      x: 780.4962263146149,
      y: 546.4502422942364,
    },
    data: {
      label: "Tarefa1",
      status: "done",
      startedAt: "2022-07-10T13:51:50",
      finishedAt: "2022-07-14T13:51:50",
      expiration: {
        number: 120,
        time: "days",
      },
      expired: false,
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "289040f7-4336-43fa-90ad-63c8109719bc",
    type: "parallel",
    position: {
      x: 1129.3096675581844,
      y: 490.5960153819681,
    },
    data: {
      label: "Paralelo",
      status: "done",
      startedAt: "2022-07-14T13:51:50",
      finishedAt: "2022-07-14T13:52:50",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "a830c005-4c23-47fa-a6df-3fa1701cfc78",
    type: "task",
    position: {
      x: 1357.1212216196718,
      y: 331.1435986621167,
    },
    data: {
      label: "Tarefa2",
      status: "done",
      startedAt: "2022-07-14T13:52:50",
      finishedAt: "2022-07-23T13:52:50",
      expiration: {
        number: 120,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "04235622-a676-4e15-b77d-ef4c46b16696",
    type: "task",
    position: {
      x: 1122.41238284681,
      y: 685.5744864824151,
    },
    data: {
      label: "Tarefa3",
      status: "done",
      startedAt: "2022-07-14T13:52:50",
      finishedAt: "2022-07-28T13:52:50",
      expired: false,
      expiration: {
        number: 360,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },

  {
    id: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    type: "conditional",
    position: {
      x: 1480.359959666273,
      y: 652.6076567020166,
    },
    data: {
      label: "Início da condicional",
      status: "done",
      startedAt: "2022-07-28T13:53:00",
      finishedAt: "2022-07-28T13:53:00",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "d5165962-aa85-4e34-b93c-9de8dcb86d6f",
    type: "timerEvent",
    position: {
      x: 1855.2976294267874,
      y: 533.6649072876598,
    },
    data: {
      status: "doing",
      startedAt: "2022-07-28T13:53:50",
      expiration: {
        number: 240,
        time: "days",
      },
    },
  },
  {
    id: "4b56d881-879f-4884-9dab-cb2136a644ae",
    type: "task",
    position: {
      x: 1878.052113691489,
      y: 754.6188162804491,
    },
    data: {
      label: "Tarefa4",
      status: "pending",
      expiration: {
        number: 120,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    type: "conditionalEnd",
    position: {
      x: 2190.8663114828646,
      y: 634.7109982948706,
    },
    data: {
      label: "Fim da condicional",
      status: "pending",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    type: "parallelEnd",
    position: {
      x: 2350.8867094521047,
      y: 475.25350632229777,
    },
    data: {
      label: "Fim do paralelo",
      status: "pending",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "000000-a676-4e15-b77d-ef4c46b16696",
    type: "task",
    position: {
      x: 2600.41238284681,
      y: 500.5744864824151,
    },
    data: {
      label: "Tarefa5",
      status: "pending",
      expiration: {
        number: 120,
        time: "days",
      },
      attachFile: false,
      lockTask: false,
      subtasks: [],
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    id: "2c18d65f-c9c1-497b-9ac1-d35893ae2820",
    type: "eventEnd",
    position: {
      x: 2950.4975834251786,
      y: 511.1326286194993,
    },
    data: {
      label: "Evento de fim",
      status: "pending",
    },
    targetPosition: "left",
    sourcePosition: "right",
  },
  {
    source: "50558059-8d5e-483d-b8a1-2bd744ad5a39",
    sourceHandle: "a",
    target: "02d5e0d2-e546-45af-991a-9647332dfa1c",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-50558059-8d5e-483d-b8a1-2bd744ad5a39a-02d5e0d2-e546-45af-991a-9647332dfa1cc",
  },
  {
    source: "02d5e0d2-e546-45af-991a-9647332dfa1c",
    sourceHandle: "a",
    target: "289040f7-4336-43fa-90ad-63c8109719bc",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-02d5e0d2-e546-45af-991a-9647332dfa1ca-289040f7-4336-43fa-90ad-63c8109719bcc",
  },
  {
    source: "289040f7-4336-43fa-90ad-63c8109719bc",
    sourceHandle: "a",
    target: "a830c005-4c23-47fa-a6df-3fa1701cfc78",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-289040f7-4336-43fa-90ad-63c8109719bca-a830c005-4c23-47fa-a6df-3fa1701cfc78c",
  },
  {
    source: "289040f7-4336-43fa-90ad-63c8109719bc",
    sourceHandle: "a",
    target: "04235622-a676-4e15-b77d-ef4c46b16696",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-289040f7-4336-43fa-90ad-63c8109719bca-04235622-a676-4e15-b77d-ef4c46b16696c",
  },
  {
    source: "a830c005-4c23-47fa-a6df-3fa1701cfc78",
    sourceHandle: "a",
    target: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    targetHandle: "b",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-a830c005-4c23-47fa-a6df-3fa1701cfc78a-4ef395e4-3648-477e-a249-2fb1fdd18c81b",
  },
  {
    source: "04235622-a676-4e15-b77d-ef4c46b16696",
    sourceHandle: "a",
    target: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "done",
    },
    id: "reactflow__edge-04235622-a676-4e15-b77d-ef4c46b16696a-b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0c",
  },
  {
    source: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    sourceHandle: "a",
    target: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    targetHandle: "b",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-ba2536cd-e735-4706-b14f-79962afdb9b8a-4ef395e4-3648-477e-a249-2fb1fdd18c81b",
  },
  //AQui

  {
    source: "4ef395e4-3648-477e-a249-2fb1fdd18c81",
    sourceHandle: "a",
    target: "000000-a676-4e15-b77d-ef4c46b16696",
    targetHandle: "a",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-4ef395e4-3648-477e-a249-2fb1fdd18c81a-000000-a676-4e15-b77d-ef4c46b16696",
  },
  {
    source: "000000-a676-4e15-b77d-ef4c46b16696",
    sourceHandle: "a",
    target: "2c18d65f-c9c1-497b-9ac1-d35893ae2820",
    targetHandle: "a",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-4000000-a676-4e15-b77d-ef4c46b16696a-2c18d65f-c9c1-497b-9ac1-d35893ae2820a",
  },

  {
    source: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    sourceHandle: "a",
    target: "4b56d881-879f-4884-9dab-cb2136a644ae",
    targetHandle: "c",
    type: "customEdge",
    data: {
      text: "Etiqueta 2",
      status: "pending",
    },
    id: "reactflow__edge-b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0a-4b56d881-879f-4884-9dab-cb2136a644aec",
  },
  {
    source: "b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0",
    sourceHandle: "a",
    target: "d5165962-aa85-4e34-b93c-9de8dcb86d6f",
    targetHandle: "a",
    type: "customEdge",
    data: {
      text: "Etiqueta 1",
      status: "done",
    },
    id: "reactflow__edge-b065c4fc-b8ba-4bdd-ac94-7fcfff63b9a0a-d5165962-aa85-4e34-b93c-9de8dcb86d6fa",
  },
  {
    source: "d5165962-aa85-4e34-b93c-9de8dcb86d6f",
    sourceHandle: "a",
    target: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-d5165962-aa85-4e34-b93c-9de8dcb86d6fa-ba2536cd-e735-4706-b14f-79962afdb9b8c",
  },
  {
    source: "4b56d881-879f-4884-9dab-cb2136a644ae",
    sourceHandle: "a",
    target: "ba2536cd-e735-4706-b14f-79962afdb9b8",
    targetHandle: "c",
    type: "customEdgeWithoutLabel",
    data: {
      status: "pending",
    },
    id: "reactflow__edge-4b56d881-879f-4884-9dab-cb2136a644aea-ba2536cd-e735-4706-b14f-79962afdb9b8c",
  },
];
